import { TDate } from "../../../TDate";

export const initialState = {
  period: "today",
  fromDate: TDate.daysToMilliseconds(TDate.dateToDays(new Date())),
  toDate: TDate.daysToMilliseconds(TDate.dateToDays(new Date())),
  applicationState: ["application"],
  products: [],
  productState: [],
  owner: [],
  ownerState: [],
  levelState: ["SUBSCRIBER", "TRIAL"],
};

type AnalyticsFilterType = {
  period: string;
  fromDate: any;
  toDate: any;
  applicationState: any[];
  products: any[];
  productState: any[];
  owner: any[];
  ownerState: any[];
  levelState: any[];
};

type actionType = {
  type: string;
  value: any;
};

export const AnalyticsFilter_reducer = (
  state: AnalyticsFilterType,
  action: actionType
) => {
  switch (action.type) {
    case "SET_PERIOD":
      return { ...state, period: action.value };
    case "SET_FROM_DATE":
      return { ...state, fromDate: action.value };
    case "SET_TO_DATE":
      return { ...state, toDate: action.value };
    case "SET_APPLICATION_STATE":
      return { ...state, applicationState: action.value };
    case "SET_PRODUCTS":
      return { ...state, products: action.value };
    case "SET_PRODUCT_STATE":
      return { ...state, productState: action.value };
    case "SET_OWNER":
      return { ...state, owner: action.value };
    case "SET_OWNER_STATE":
      return { ...state, ownerState: action.value };
    case "SET_LEVEL_STATE":
      return { ...state, levelState: action.value };
    case "CLEAR_FILTER":
      return initialState;
    default:
      return state;
  }
};
